import { useQuery } from '@tanstack/react-query';
import { getSlidesDataForArtifactsResults } from 'api/study';
import { size } from 'lodash';
import { useMemo } from 'react';

import { CasesParams } from 'utils/useCasesParams/types';
import { resolveMultiplexActionSelection } from './helpers';

export const useMultiplexActionSelection = (
  casesParams: CasesParams,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  const needsCaseResolution = !size(casesParams.slideIdsToInclude);
  const studyId = casesParams.studyId ?? casesParams.filters?.studyId;
  const slidesQuery = useQuery({
    queryKey: ['multiplexActionSelectionSlides', casesParams],
    queryFn: ({ signal }) => getSlidesDataForArtifactsResults(casesParams, signal),
    enabled: enabled && needsCaseResolution && Boolean(studyId),
  });

  const resolution = useMemo(
    () =>
      resolveMultiplexActionSelection({
        casesParams,
        slides: slidesQuery.data,
      }),
    [casesParams, slidesQuery.data]
  );

  return {
    ...resolution,
    isLoadingSelection: enabled && needsCaseResolution && (slidesQuery.isLoading || slidesQuery.data === undefined),
  };
};
